import CacheBuster from './CacheBuster.jsx';

export default CacheBuster;


// WEBPACK FOOTER //
// ./src/components/CacheBuster/index.js